import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Medals from '../components/Medals/index';
import * as Actions from '../models/medals/actions';


const mapStateToProps = state => ({
    answer: state.medals
});


const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});


const MedalContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Medals);

export default MedalContainer;



// WEBPACK FOOTER //
// ./src/containers/MedalTable.container.js